import { PaymentMethod as PaymentMethodType } from "@/types"

export const PaymentMethod = ({ paymentMethod }: { paymentMethod: PaymentMethodType }) => {
  const paymentMethodMap: Record<string, string> = {
    "CARD": "Cartão de crédito",
    "CREDIT": "Cartão de crédito",
    "DEBIT": "Cartão de débito",
    "CASH": "Dinheiro",
    "PIX": "Pix",
    "PIX_ONLINE": "Pix Online",
  }
  return <span>{paymentMethodMap[paymentMethod] ?? paymentMethod}</span>
}